var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "mb-4 text-xl font-bold" }, [
      _vm._v("Requirements check")
    ]),
    _c("p", { staticClass: "mb-4 text-xl" }, [
      _vm._v(
        " Make sure to follow the requirements and guidelines below to set up and prepare for a successful trial. "
      )
    ]),
    _vm._m(0),
    _vm._m(1),
    _c(
      "div",
      {
        staticClass: "d-flex justify-end align-center flex-wrap",
        staticStyle: { gap: "8px" }
      },
      [
        _c("va-button", {
          attrs: { type: "outline", cta: _vm.$t("trial.back") },
          on: {
            click: function($event) {
              return _vm.$emit("prev")
            }
          }
        }),
        _c("va-button", {
          attrs: { cta: _vm.$t("trial.verificationComplete") },
          on: {
            click: function($event) {
              return _vm.$emit("next")
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticClass: "trial-table border-a mb-4" }, [
      _c("tbody", [
        _c("tr", [
          _c("td", { staticClass: "font-weight-bold border-b pa-3" }, [
            _vm._v("Operating System")
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "border-b pa-3" }, [
            _c("ul", { staticClass: "trial-list" }, [
              _c("li", [_vm._v("Android 10 or newer (64-bit only)")])
            ])
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "font-weight-bold border-b pa-3" }, [
            _vm._v("Network")
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "border-b pa-3" }, [
            _c("ul", { staticClass: "trial-list" }, [
              _c("li", [_vm._v("Wired Ethernet (recommended)")]),
              _c("li", [_vm._v("WiFi 802.11ac (at least -60 dBm)")])
            ])
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "font-weight-bold border-b pa-3" }, [
            _vm._v("Device types")
          ])
        ]),
        _c("tr", [
          _c("td", { staticClass: "pa-3" }, [
            _c("ul", { staticClass: "trial-list" }, [
              _c("li", [_vm._v("Interactive Flat Panels (IFPs)")]),
              _c("li", [_vm._v("Android TVs / Google TV")]),
              _c("li", [_vm._v("Amazon FireTV")]),
              _c("li", [_vm._v("Video Bars")]),
              _c("li", [_vm._v("OPS modules")])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mb-4 text-xl" }, [
      _vm._v(
        " For the full list of requirements and a list of tested devices please refer to our "
      ),
      _c(
        "a",
        {
          attrs: { href: "https://kb.mago.io/requirements", target: "_blank" }
        },
        [_vm._v("knowledge base")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }